import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { EntryService } from 'src/app/services/entry.service';
import { Entry } from 'src/app/models/entry';

@Component({
    selector: 'app-entries',
    templateUrl: './entries.component.html',
    styleUrls: ['./entries.component.scss'],
    standalone: false
})
export class EntriesComponent implements OnInit {

  entries: Observable<any[]>;
  constructor(private _entryService: EntryService) { }

  ngOnInit(): void {
    this.entries = this._entryService.list();
  }
  update(entry: Entry) {
    this._entryService.update(entry);
  }

}
